//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
	props: ['query', 'sortitems'],
	computed: {
		...mapState({
			filterDropdown: ({ dropdownStore: {filterDropdown} }) => filterDropdown,
			filter: ({ filtersStore: { filter } }) => filter
		}),
	},
	components: {
		oldest: () => import('~/components/filters/sort/oldest.vue'),
		recommended: () => import('~/components/filters/sort/recommended.vue'),
		watched: () => import('~/components/filters/sort/watched.vue'),
		recent: () => import('~/components/filters/sort/recent.vue'),
		shuffle: () => import('~/components/filters/sort/shuffle.vue'),
		newestVideo: () => import('~/components/filters/sort/newest_video.vue'),
	},
}
